import { useState } from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import './treeImportStyles.scss';

interface Props {
  category: any;
  onToggleCategory: (category: any) => void;
  isSelected: boolean;
  disabled?: boolean;
  // ADICIONE esta nova prop para verificar o estado de cada categoria
  isCategorySelected?: (categoryId: number) => boolean;
}

function TreeImport({
  category,
  onToggleCategory,
  isSelected,
  disabled = false,
  isCategorySelected,
}: Props) {
  const [expand, setExpand] = useState(false);
  
  const hasChildren = category?.relationships?.children?.length > 0;

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    onToggleCategory(category);
  };

  return (
    <>
      <div className="tree-import-item" style={{ paddingTop: '10px' }}>
        <div
          className={`tree-import-col ${
            hasChildren ? 'subCategoryBackGroup' : 'categoryBackGroup'
          }`}
        >
          <section className="tree-import-section">
            <div className="tree-import-content">
              <input
                type="checkbox"
                checked={isSelected}
                onChange={handleCheckboxChange}
                disabled={disabled}
                className="tree-import-checkbox"
                onClick={(e) => e.stopPropagation()}
              />
              
              <span className="tree-import-name">
                {category?.name?.toUpperCase()}
              </span>

              {hasChildren && (
                <button 
                  onClick={() => setExpand(!expand)}
                  className="tree-import-expand-btn"
                  type="button"
                >
                  {expand ? (
                    <MdKeyboardArrowUp size={20} color="#a1a5b7" />
                  ) : (
                    <MdKeyboardArrowDown size={20} color="#a1a5b7" />
                  )}
                </button>
              )}
            </div>
          </section>
        </div>

        {hasChildren && (
          <div style={{ display: expand ? 'block' : 'none' }}>
            {category?.relationships?.children?.map((childCategory: any) => (
              <div
                className="tree-import-child"
                key={childCategory?.id}
              >
                <TreeImport
                  category={childCategory}
                  onToggleCategory={onToggleCategory}
                  // CORREÇÃO: Verificar se ESTA subcategoria específica está selecionada
                  isSelected={isCategorySelected ? isCategorySelected(childCategory.id) : false}
                  disabled={disabled}
                  // IMPORTANTE: Passar a função para as subcategorias também
                  isCategorySelected={isCategorySelected}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}

export default TreeImport;